import { render, staticRenderFns } from "./backbill.vue?vue&type=template&id=447330f8&scoped=true&"
import script from "./backbill.vue?vue&type=script&lang=js&"
export * from "./backbill.vue?vue&type=script&lang=js&"
import style0 from "./backbill.vue?vue&type=style&index=0&id=447330f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447330f8",
  null
  
)

export default component.exports